import styled from 'styled-components';
import {
  cssColorValue,
  desktopCelloCanon,
  mobileCello,
  PopoverNavigationItem,
  screenXsMin,
  semanticColors,
  spacer20,
  spacer32,
  spacer4,
  TextLink,
} from '@spotify-internal/encore-web/core';

export const SideMenuNavigationList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${spacer20};
  list-style-type: none;
  margin-bottom: ${spacer32};
  margin-top: 0;
  padding: 0;
`;

export const SideMenuNavigationItem = styled(PopoverNavigationItem)`
  ${desktopCelloCanon};

  @media (max-width: ${screenXsMin}) {
    ${mobileCello}
  }
`;

export const SideMenuNavigationLink = styled(TextLink)`
  && {
    color: ${cssColorValue(semanticColors.textBase)};
    text-decoration: none;
    ${desktopCelloCanon};

    &&:active,
    &&:hover,
    &&:focus {
      box-shadow: none;
      color: ${cssColorValue(semanticColors.textBase)};
      text-decoration: none;
    }

    &:focus {
      outline: 5px auto -webkit-focus-ring-color;
      outline-offset: ${spacer4};
    }

    @media (max-width: ${screenXsMin}) {
      ${mobileCello}
    }
  }
`;
